<script>
import { VBtn } from "vuetify/lib";

export default {
  name: "Btn",
  props: {
    tile: {
      type: Boolean,
      default: true,
    },
  },
  extends: VBtn,
};
</script>
